import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'p-button-filter',
    templateUrl: './button-filter.component.html',
    styleUrls: ['./button-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ButtonFilterComponent implements OnInit {
  @Input() selectedItem: string;
  @Input() buttons: [{key: string; value: string}];
  @Input() disabled = false;
  @Output() selectedItemChange = new EventEmitter<string>();
  @Output() onChange = new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
    return;
  }

  changeSelectedItem(newValue: string) {
    this.selectedItemChange.emit(newValue);
    this.onChange.emit(newValue);
  }

}
